export default {
  name: 'AppDropdownItem'
};